import React, { useEffect, useState, useRef } from 'react'
import translate from '../../../i18n/translate'
import useSound from '../../views/MetaberryView/hooks/useSound'
import { ReactComponent as SvgGoldGear } from '../../../assets/img/metaberry_ui/gold-gear.svg'
import DynamicTextContainer from '../../atoms/DynamicTextContainer/DynamicTextContainer'
import TitleContainer from '../../atoms/TextContainer/TextContainer'

// import { Analysis } from '../../../services/analysisService'
// import { getCourseGuid } from '../../../assets/data/api'
// import { store } from '../../../store/configureStore'

const MetaLessonPanel = ({
  status: initialStatus,
  isAvailable: initialIsAvailable,
  pieces: initialPieces,
  unitGuid,
  lessonGuid,
  lessonName,
  lessonNumber,
  previousLessonGuid,
  previousLessonName,
  previousLessonImage,
  handleEnterButton,
  currentTileSize,
  playerScreenPosition,
  batteryScreenPosition,
  isFixed
}) => {
  const refContainer = useRef()

  const [BackgroundCircleImage] = useState(
    `${process.env.PUBLIC_URL}/assets/graphics/images/background-gradient-circle.svg`
  )

  const [panelStyle, setPanelStyle] = useState({
    top: 1,
    left: 1,
    visibility: 'hidden',
    transition: 'none'
  })
  const [piecesHave, setPiecesHave] = useState(0)
  const [piecesTotal, setPiecesTotal] = useState(0)
  const [status, setStatus] = useState(initialStatus)
  const [isAvailable, setIsAvailable] = useState(initialIsAvailable)
  const [pieces, setPieces] = useState(initialPieces)

  const { renderSoundFXController, playSoundEffectWithConfig } = useSound()

  useEffect(() => {
    playSoundEffectWithConfig('portalInfo')

    calculatePieces(initialPieces)

    if (!isFixed) {
      // Calcular posición del panel en base al personaje y la batería activa
      const gameContainer = document.querySelector('#phaser-game')
      const thisPanel = refContainer.current

      // Asegurar que se puede modificar
      let panelX = Math.round(window.outerWidth / 2)
      let panelY = Math.round(window.outerHeight / 2)
      if (
        gameContainer &&
        thisPanel &&
        playerScreenPosition?.x &&
        batteryScreenPosition?.x &&
        currentTileSize
      ) {
        const gameRect = gameContainer.getBoundingClientRect()
        const panelWidth = thisPanel.offsetWidth
        const panelHeight = thisPanel.offsetHeight

        panelX = getPanelX(
          gameRect,
          playerScreenPosition,
          batteryScreenPosition,
          panelWidth,
          currentTileSize
        )

        panelY = getPanelY(
          gameRect,
          playerScreenPosition,
          batteryScreenPosition,
          panelHeight,
          currentTileSize
        )

        const [adjustedPanelX, adjustedPanelY] = checkPanelOutsideWindow(
          panelX,
          panelY,
          panelWidth,
          panelHeight,
          currentTileSize
        )
        panelX = adjustedPanelX
        panelY = adjustedPanelY
      }

      setPanelStyle({
        top: panelY,
        left: panelX,
        visibility: 'visible',
        transition: 'none'
      })

      window.addEventListener('player-moved', updatePosition)
    }

    const handleUpdate = (event) => {
      const {
        status: newStatus,
        isAvailable: newIsAvailable,
        pieces: newPieces
      } = event.detail

      if (newStatus !== undefined) setStatus(newStatus)
      if (newIsAvailable !== undefined) setIsAvailable(newIsAvailable)
      if (newPieces !== undefined) setPieces(newPieces)

      calculatePieces(newPieces)
    }

    window.addEventListener('update-lesson-panel', handleUpdate)

    return () => {
      window.removeEventListener('update-lesson-panel', handleUpdate)
      if (!isFixed) window.removeEventListener('player-moved', updatePosition)
    }
  }, [])

  function calculatePieces(lessonPieces) {
    if (lessonPieces?.have) {
      setPiecesHave(
        lessonPieces.have.reduce((total, current) => total + current, 0)
      )
    }

    if (lessonPieces?.pieces) {
      setPiecesTotal(
        lessonPieces.pieces.reduce((total, current) => total + current, 0)
      )
    }
  }

  function isPlayerInPanelArea_Horizontal(
    playerLeftX,
    playerRightX,
    areaLeft,
    areaRight
  ) {
    const isOverlaped =
      areaLeft - 2 < playerRightX && playerLeftX < areaRight + 2

    return isOverlaped
  }

  function getPanelX(
    gameRect,
    playerPosition,
    batteryPosition,
    panelWidth,
    tileSize
  ) {
    // Posibles posiciones
    // 1 Derecha                    2 Derecha más 1 tile
    // 3 Izquierda                  4 Izquierda menos 1 tile
    // 5 forzado exterior derecha   6 Menor de los males
    const halfTile = Math.round(tileSize * 0.5)
    const panelXBaseRight = batteryPosition.x + tileSize + halfTile
    const panelXBaseLeft = batteryPosition.x - panelWidth - halfTile
    const playerLeftX = playerPosition.x - halfTile
    const playerRightX = playerPosition.x + halfTile

    // Se comprueba si cabe en el lado derecho
    let panelLeft = panelXBaseRight
    let panelRight = panelLeft + panelWidth

    if (
      panelRight + tileSize < gameRect.width &&
      !isPlayerInPanelArea_Horizontal(
        playerLeftX,
        playerRightX,
        panelLeft,
        panelRight
      )
    ) {
      return panelLeft
    } else {
      // Se comprueba si cabe en el lado derecho + 1 tile de espacio para el personaje
      panelLeft += tileSize
      panelRight += tileSize

      if (
        panelRight + tileSize < gameRect.width &&
        !isPlayerInPanelArea_Horizontal(
          playerLeftX,
          playerRightX,
          panelLeft,
          panelRight
        )
      ) {
        return panelLeft
      } else {
        // Se comprueba si cabe en el lado izquierdo
        panelLeft = panelXBaseLeft
        panelRight = panelLeft + panelWidth

        if (
          panelLeft > tileSize &&
          !isPlayerInPanelArea_Horizontal(
            playerLeftX,
            playerRightX,
            panelLeft,
            panelRight
          )
        ) {
          return panelLeft
        } else {
          // Se comprueba si cabe en el lado izquierdo - 1 tile de espacio para el personaje
          panelLeft -= tileSize
          panelRight -= tileSize

          if (
            panelLeft > tileSize &&
            !isPlayerInPanelArea_Horizontal(
              playerLeftX,
              playerRightX,
              panelLeft,
              panelRight
            )
          ) {
            return panelLeft
          } else {
            // Si es obligatorio se escoge la mejor de las peores opciones
            panelLeft = panelXBaseRight
            panelRight = panelLeft + panelWidth

            if (panelRight + tileSize < gameRect.width) {
              return panelLeft
            } else {
              return panelXBaseLeft + halfTile
            }
          }
        }
      }
    }
  }

  function getPanelY(
    gameRect,
    playerPosition,
    batteryPosition,
    panelHeight,
    tileSize
  ) {
    const halfTile = Math.round(tileSize * 0.5)

    // Se comprueba si se sale por arriba (con 1 tile de margen), sino se baja
    let panelY = batteryPosition.y - halfTile
    if (panelY < tileSize) panelY = tileSize

    // Se comprueba si se sale por debajo, sino se sube
    const overflowY = gameRect.height - (panelY + panelHeight + tileSize)
    if (overflowY < 0) {
      panelY += overflowY
    }

    return panelY
  }

  function checkPanelOutsideWindow(
    panelX,
    panelY,
    panelWidth,
    panelHeight,
    tileSize
  ) {
    const halfTile = Math.round(tileSize * 0.5)

    if (panelX < halfTile) panelX = halfTile
    if (panelY < halfTile) panelY = halfTile
    if (panelX + panelWidth > window.innerWidth - halfTile)
      panelX = window.innerWidth - panelWidth - halfTile
    if (panelY + panelHeight > window.innerHeight - halfTile)
      panelY = window.innerHeight - panelHeight - halfTile

    return [panelX, panelY]
  }

  // eslint-disable-next-line no-unused-vars
  function updatePosition(event) {
    if (!isFixed) {
      const playerPosition = event.detail.playerPosition
      const batteryPosition = event.detail.batteryPosition
      const tileSize = event.detail.currentTileSize
      // Calcular posición del panel en base al personaje y la batería activa
      const gameContainer = document.querySelector('#phaser-game')
      const thisPanel = refContainer.current

      if (
        gameContainer &&
        thisPanel &&
        playerPosition?.x &&
        batteryPosition?.x &&
        tileSize
      ) {
        const gameRect = gameContainer.getBoundingClientRect()
        const panelWidth = thisPanel.offsetWidth
        const panelHeight = thisPanel.offsetHeight

        let panelX = getPanelX(
          gameRect,
          playerPosition,
          batteryPosition,
          panelWidth,
          tileSize
        )

        let panelY = getPanelY(
          gameRect,
          playerPosition,
          batteryPosition,
          panelHeight,
          tileSize
        )

        const [adjustedPanelX, adjustedPanelY] = checkPanelOutsideWindow(
          panelX,
          panelY,
          panelWidth,
          panelHeight,
          tileSize
        )
        panelX = adjustedPanelX
        panelY = adjustedPanelY

        if (panelStyle.left !== panelX || panelStyle.top !== panelY) {
          setPanelStyle((prevStyle) => ({
            ...prevStyle,
            top: panelY,
            left: panelX,
            visibility: 'visible',
            transition: 'top 500ms, left 500ms'
          }))
        }
      }
    }
  }

  function getButtonText(status) {
    const hasAllPieces =
      JSON.stringify(pieces.have) === JSON.stringify(pieces.pieces)

    const texts = {
      install: 'lesson_install_btn',
      empty: 'lesson_recharge_btn',
      init: 'lesson_recharge_btn',
      charging: 'lesson_recharge_btn',
      complete: hasAllPieces ? 'lesson_practice_btn' : 'lesson_get_pieces_btn',
      start: hasAllPieces ? 'lesson_practice_btn' : 'lesson_get_pieces_btn',
      broked_start: 'lesson_repair_btn'
    }

    return translate(texts[status])
  }

  return (
    <div
      className={'meta-lesson-panel phaser-dom'}
      style={panelStyle}
      ref={refContainer}
      data-fixed={isFixed}
    >
      <div
        className="meta-lesson-panel_decoration"
        style={{ backgroundImage: `url(${BackgroundCircleImage})` }}
      ></div>
      {renderSoundFXController()}
      {!isAvailable ? (
        <div className="meta-lesson-panel__blocked">
          <TitleContainer
            titleText={translate('lesson_blocked')}
            className="meta-lesson-panel__blocked-title"
          />
          <div className="meta-lesson-panel__blocked-info">
            {translate('lesson_blocked_info')}
          </div>
          {previousLessonImage && (
            <div className="meta-lesson-panel__previous-image">
              <img src={previousLessonImage} />
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="meta-lesson-panel__lesson-number">
            {`${translate('lesson_battery_number')} ${lessonNumber}`}
          </div>
          <DynamicTextContainer
            className="meta-lesson-panel__lesson-title"
            titleText={lessonName}
          ></DynamicTextContainer>

          <div className="meta-lesson-panel__lesson-pieces">
            <div className="meta-lesson-panel__lesson-pieces_gear">
              <SvgGoldGear />
            </div>
            <div className="meta-lesson-panel__lesson-pieces_bar">
              <div
                className="meta-lesson-panel__lesson-pieces_bar_foregrond"
                style={{ width: (piecesHave * 100) / piecesTotal + '%' }}
              ></div>
            </div>
            <div className="meta-lesson-panel__lesson-pieces_number">
              <div>{piecesHave}</div>
              <div>{'/'}</div>
              <div>{piecesTotal}</div>
            </div>
          </div>

          <div
            className="meta-lesson-panel__button"
            onClick={() => {
              playSoundEffectWithConfig('uiButton')
              handleEnterButton()
            }}
            data-testid="meta_lesson_panel_button"
          >
            {getButtonText(status)}
          </div>
        </>
      )}
    </div>
  )
}

export default MetaLessonPanel
